// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../../routes/routes";
import phrasebookLoad from "../../../i18n";
import { capitalizeFirstLetter } from "../../../helpers/util"
import * as token from '../../../helpers/token';
import { accountTypesConstants } from '../../../constants';
import { initialState, submitValues, serviceNumberTypeForm } from './serviceNumberTypeForm';

// Redux
import { vendorActions, serviceNumberTypeActions, georesourceActions } from 'actions';

// Components
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton, CancelButton, OnClickButton } from "../../../components/SkyFramework/Buttons";
import { Form } from "../../../components/SkyFramework/Forms";

// Constants
const phrasebook = phrasebookLoad()

class ServiceNumberTypeAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState(phrasebook)
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addCity = this.addCity.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(vendorActions.getAll(0, 0, undefined));
    this.props.dispatch(georesourceActions.getCountryCodes(0, 0, undefined));
  }

  componentDidUpdate(prevProps) {
    if (this.props.vendors && prevProps && prevProps.vendors !== this.props.vendors) {
      this.setState({ vendors: this.props.vendors });
    }
    if (this.props.dialcodes && prevProps && prevProps.dialcodes !== this.props.dialcodes) {
      this.setState({ dialcodes: this.props.dialcodes });
    }
    if (this.props.uploaderror && prevProps && prevProps.uploaderror !== this.props.uploaderror) {
      this.setState({ [this.props.uploaderror]: undefined });
    }

  }

  uploadFile(e) {
    const { id, files } = e.target;
    const file = files[0];
    if (file) {
      this.props.dispatch(serviceNumberTypeActions.uploadFile(file, file.name, id, ['pdf', 'doc', 'docx']))
      this.setState({ [id]: file.name })
    }

  }

  handleChange(e) {
    const { id, name, value, checked, type } = e.target;
    if (type === 'checkbox' && checked !== undefined) {
      this.setState({ [id]: checked });
      if (id === 'end_user_address_req' && checked === false) {
        this.setState({
          end_user_address_req: false,
          end_user_address_proof_req: false,
          end_user_address_type: undefined,
          end_user_address_proof_required: undefined
        });
      }
      else if (id === 'concurrent_call_expandable') {
        if (checked === false) this.setState({ conc_max_callpnumber: undefined });
        else this.setState({ conc_df_callpernumber: undefined });
      }
      else if (id === 'portability' && checked === false) {
        this.setState({
          portability_options: [],
          prt_consentletter_req: false,
          prt_consentletter_link: undefined,
          prt_hstcarriers_req: false,
          portability_forms: false,
          portability_forms_link: undefined,
          portability_latest_invoices_req: false
        });
      }
      else if (id === 'declaration_letter_req' && checked === false) {
        this.setState({
          declaration_letter_link: undefined
        });
      }
      else if (id === 'portability' && checked === true) {
        this.setState({
          portability_options: ['between in country carriers'],
        });
      }
      else if (id === 'accessibility' || id === 'portability_options') {
        if (checked === true && !this.state[id].includes(name)) {
          var arraytemp = this.state[id];
          arraytemp.push(name);
          this.setState({
            [id]: arraytemp
          })
        } else if (checked === false && this.state[id].includes(name)) {
          let result = this.state[id].filter(e => e !== name);
          this.setState({
            [id]: result
          })
        }
      }
    }
    else if (id) {
      if (id === 'jurisdiction') {
        const country_values = JSON.parse(value);
        this.setState({
          jurisdiction: country_values.name,
          jurisdiction_dial_code: country_values.dialcode
        });
      }
      else if (id.includes("city_dial_code")) {
        var index = id.replace('city_dial_code', '');
        var cities_array = this.state.cities;
        if (cities_array.length > index && typeof cities_array[index] !== 'undefined') {
          var city = this.state.cities[index];
          city.city_dial_code = value;
          cities_array[index] = city;
        } else {
          cities_array = [{ city: undefined, city_dial_code: value }];
        }
        this.setState({ cities: cities_array });
      }
      else if (id.includes("city")) {
        var index = id.replace('city', '');
        var cities_array = this.state.cities;
        if (cities_array.length > index && typeof cities_array[index] !== 'undefined') {
          var city = this.state.cities[index];
          city.city = value;
          cities_array[index] = city;
        } else {
          cities_array = [{ city: value, city_dial_code: undefined }];
        }
        this.setState({ cities: cities_array });
      }

      else {
        if (id === 'service_type' && ['ITFN', 'DID', 'SIP Trunking'].includes(value)) {
          this.setState({ itu_assignment_notification_req: false });
        }
        if (id === 'service_type' && (value === 'ITFN' || value === 'UIFN')) {
          this.setState({ number_type: undefined, cities: undefined });
        }
        if (id === 'service_type' && (value === 'DID' || value === 'SIP Trunking')) {
          this.setState({ cities: [{ city: undefined, city_dial_code: undefined }] });
        }

        this.setState({ [id]: value });
      }
    }

    else if (name) this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var newValues = submitValues(this.state);
    this.props.dispatch(serviceNumberTypeActions.add(newValues));

  }

  addCity(e) {
    e.preventDefault();
    var cities = this.state.cities;
    cities.push({ city: undefined, city_dial_code: undefined })
    this.setState({ cities: cities });
  }

  FormServiceNumberType = () => {
    if (this.state.vendors && this.state.dialcodes) {
      const vendorOptions = this.state.vendors.data.map(function (vendor) {
        return { value: vendor['id'], label: vendor['name'] };
      });

      const dialcodeOptions = this.state.dialcodes.data.map(function (dialcode) {
        return { value: JSON.stringify({ name: dialcode.name, dialcode: dialcode.dial_code }), label: dialcode['name'] };
      });


      const inputs = serviceNumberTypeForm(phrasebook, this.state, { vendors: vendorOptions, dialcodes: dialcodeOptions }, this.addCity);

      const buttons = [<CancelButton title={phrasebook.common.back} link={gisRoutes.management.service_number_type.list} />, <SubmitButton title={phrasebook.common.add} />]
      return (
        <Form
          handleSubmit={this.handleSubmit}
          onChange={this.handleChange}
          uploadFile={this.uploadFile}
          title={`${phrasebook.common.add} ${phrasebook.numbers.service_number_type}`}
          inputs={inputs}
          buttons={buttons}
        />)
    } else return null;
  }

  render() {
    return <>

      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.management.service_number_type.list, label: phrasebook.numbers.service_number_type }]} current={`${phrasebook.common.add} ${phrasebook.numbers.service_number_type}`} />

      {this.FormServiceNumberType()}
    </>
  }
}

function mapStateToProps(state) {
  const { authentication, georesource, vendor, servicenumbertype } = state;
  const { authUser } = authentication;
  return {
    authUser,
    vendors: vendor.vendors,
    dialcodes: georesource.dialcodes,
    uploaderror: servicenumbertype.uploaderror
  };
}


const serviceNumberTypeAdd = connect(mapStateToProps)(ServiceNumberTypeAdd);
export default (serviceNumberTypeAdd);
